import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    const parser = new URL(this.data.get("url"), location)

    this.url = parser.pathname
    if (!parser.pathname.endsWith(".js")) {
      this.url = this.url.concat(".js")
    }
    this.url = this.url.concat(parser.search)
    this.interval = this.data.get("interval")

    // this.startRefreshing()
  }

  disconnect() {
    this.stopRefreshing()
  }

  load() {
    if (!$(this.element).find(".dropdown.show").length) {
      $.ajax({
        url: this.url
      })
    }
  }

  startRefreshing() {
    this.refreshTimer = setInterval(() => {
      this.load()
    }, this.interval)
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }
}
